(ns practitest.frontend.components2.dashboard.dashboard-tab-menu
  "Kebab menu for a dashboard tab (Edit / Clone / Archive or Unarchive / Delete).
   Shared by the dashboards settings page and the summary page."
  (:require [practitest.frontend.common.i18n :refer [get-translation]]
            [practitest.frontend.components.icons :as icons]
            [practitest.frontend.components2.grid.row-menu :as row-menu]))

(defn dashboard-tab-menu
  "`tab` is the tab json ({:editable :archived ...}).
   Callbacks receive no args; pass nil to hide the action.
   `last-unarchived?` disables Archive (the last available tab cannot be archived).
   `placement` - optional floating-ui placement of the menu (defaults to \"left-start\")."
  [{:keys [tab last-unarchived? on-edit on-clone on-archive on-unarchive on-delete placement]}]
  (let [{:keys [editable archived]} tab]
    [row-menu/row-menu
     tab
     (not editable)
     [(when (and editable on-edit (not archived))
        {:id       "dashboard-tab-edit"
         :icon     icons/mux-pencil
         :label    (get-translation "dashboards.tab-menu.edit" "Edit Tab")
         :on-click on-edit})
      (when (and editable on-clone)
        {:id       "dashboard-tab-clone"
         :icon     icons/mux-clone
         :label    (get-translation "dashboards.tab-menu.clone" "Clone Tab")
         :on-click on-clone})
      (when (and editable on-archive (not archived))
        {:id        "dashboard-tab-archive"
         :icon      icons/mux-archive-2
         :label     (get-translation "dashboards.tab-menu.archive" "Archive Tab")
         :disabled? last-unarchived?
         :tooltip   (when last-unarchived?
                      (get-translation "dashboards.tab-menu.archive-last" "You cannot archive the last available dashboard."))
         :on-click  on-archive})
      (when (and editable on-unarchive archived)
        {:id       "dashboard-tab-unarchive"
         :icon     icons/mux-archive
         :label    (get-translation "dashboards.tab-menu.unarchive" "Unarchive Tab")
         :on-click on-unarchive})
      (when (and editable on-delete)
        {:id           "dashboard-tab-delete"
         :icon         icons/mux-trash
         :class        "danger"
         :label        (get-translation "dashboards.tab-menu.delete" "Delete Tab")
         :on-click     on-delete
         :confirmation {:title     (get-translation "dashboards.confirm.delete-tab.title" "Delete Tab?")
                        :body      (get-translation "dashboards.confirm.delete-tab.body"
                                                    "Are you sure you want to delete this tab? This operation cannot be undone")
                        :yes-label (get-translation "generic.button.delete" "Delete")
                        :no-label  (get-translation "generic.button.cancel" "Cancel")}})]
     {:tooltip   (when-not editable
                   (get-translation "dashboards.no-permission" "You don't have permissions to edit this dashboard tab"))
      :placement placement}]))
